import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MailerDnsInfoModalComponent } from './mailer-dns-info-modal.component';

@NgModule({
  declarations: [MailerDnsInfoModalComponent],
  imports: [CommonModule],
})
export class MailerDnsInfoModalModule {}
